import { GameCommunicationConnectionObserver as CoreCommunicationConnectionObserver, ConnectionStatus } from '@pp/core';

import { GameStore } from '../../store/GameStore';
import { mwStateActions } from '../../store/slices/mwState/slice';
import { fetchRecentResultsAction } from '../../store/apiActions/fetchRecentResultsAction';

export class GameCommunicationConnectionObserver extends CoreCommunicationConnectionObserver {
  update(connectedStatus: ConnectionStatus, store: GameStore): void {
    const recentResultsCount = store.getState().mwGameState.recentResultsCount;
    const JSESSIONID = store.getState().config.session?.JSESSIONID;
    const tableId = store.getState().config.session?.tableId;
    const gsAddress = store.getState().config.tableConfig?.gsAddress;

    switch (connectedStatus) {
      // If comes from reconnecting, reset the state
      case ConnectionStatus.RECONNECTING:
        store.dispatch(mwStateActions.resetAfterReconnection());
        break;
      // If reconnected, re-fetch recent results
      case ConnectionStatus.RECONNECTED:
        // refetch recent results (for cases when result was updated during player was disconnected)
        if (recentResultsCount && JSESSIONID && gsAddress && tableId) {
          store.dispatch(
            fetchRecentResultsAction({
              JSESSIONID,
              tableId,
              numberOfGames: recentResultsCount,
              url: `${gsAddress}/api/ui/statisticHistory`,
              force: true,
            })
          );
        }
    }
    super.update(connectedStatus, store);
  }
}
